import type { FC, ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import useCustomMedia from 'src/hooks/useCustomMedia';
import Footer from 'src/components/common/Footer';
import LanguageSwitcher from 'src/components/common/LanguageSwitcher';

import { styles } from './PageLayoutDesktop.styles';

interface PageLayoutDesktopProps {
  children: ReactNode;
}

const PageLayoutDesktop: FC<PageLayoutDesktopProps> = ({ children }) => {
  const { corporateLogoPath, toolLogoPath, toolName } = useCustomMedia();

  return (
    <Stack direction="row" sx={{ height: '100vh' }}>
      <Stack sx={[styles.halfPageWrapper, styles.formBackground]} spacing={4}>
        <Box sx={{ position: 'absolute', p: 4, right: 0, top: 0 }}>
          <LanguageSwitcher />
        </Box>
        {!!toolLogoPath && (
          <Stack direction="row" sx={styles.toolLogoBox}>
            <Stack direction="column">
              <Box sx={styles.toolLogoWrapper}>
                <img
                  src={toolLogoPath}
                  alt="Tool logo"
                  width="auto"
                  height="100%"
                />
              </Box>
              {!!toolName && (
                <Typography variant="h4" sx={styles.toolName}>
                  {toolName}
                </Typography>
              )}
            </Stack>
          </Stack>
        )}
        <Stack direction="row" sx={styles.formBox}>
          <Stack direction="column" sx={{ flexGrow: 1, ...styles.formWrapper }}>
            <Box sx={styles.formOverflowHandler}>{children}</Box>
          </Stack>
        </Stack>
        <Footer />
      </Stack>
      <Stack sx={[styles.halfPageWrapper, styles.logoBackground]}>
        <Stack direction="column" sx={styles.imageBox}>
          <Stack direction="row" sx={styles.imageWrapper}>
            {!!corporateLogoPath && (
              <img
                src={corporateLogoPath}
                alt="Corporate logo"
                width="100%"
                height="auto"
              />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default PageLayoutDesktop;
